import React, { useEffect, useState } from "react";
import styles from "./SetupOrganisation.module.css";
import { setHeader } from "../../reduxSlices/headerSlice";
import { useDispatch, useSelector } from "react-redux";
import VFLogo from "../../assets/images/vf-logo.png";
import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import ButtonCta1 from "../../components/button/ButtonCta1";
import { Service } from "../../services/service";
import { USER_ROLE_ID, toastConfig } from "../../constants/constant";
import { toast } from "react-toastify";
import {
  getUserLogin,
  getUserLoginByUserId,
} from "../../reduxSlices/userSlice";
import { Navigate, useNavigate } from "react-router-dom";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import CreateUser from "../../components/user/CreateUser";

const service = new Service();

const SetupOrganisation = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userData = useSelector((state) => state?.user);
  const userRole = userData?.userRoleId;
  const currentUser = userData?.currentUser?.data;
  const organisationName = userData?.organisationName;

  const [value, setValue] = useState("standard");
  const [user, setUser] = useState({
    userId: "",
    emailId: "",
    familyName: "",
    givenName: "",
    organization: {},
    isActive: true,
    isAdmin: true,
    roles: [],
  });

  useEffect(() => {
    setValue(userRole?.includes(USER_ROLE_ID) ? "standard" : "admin");
  }, [userRole]);

  useEffect(() => {
    setUser({
      userId: currentUser?.userId,
      emailId: currentUser?.emailId,
      familyName: currentUser?.familyName,
      givenName: currentUser?.givenName,
      organization: currentUser?.organization,
      isActive: currentUser?.isActive,
      isAdmin: currentUser?.isAdmin,
      roles: currentUser?.roles,
    });
  }, [currentUser]);

  console.log("currentUser", currentUser);

  useEffect(() => {
    dispatch(
      setHeader({
        page: "setup-organisation",
        title: "Setup Organisation",
        subTitle: "",
      })
    );
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    updateUser();
  };

  const updateUser = async () => {
    let url = `/api/User/UpdateUser`;
    const user_token = localStorage.getItem("bb_access_token");
    const userData = prepareUserData();
    const formData = JSON.stringify(userData);
    try {
      let data = await service.newPutApi(url, formData, user_token);
      let resp = data.data;
      let emailId = resp.emailId;
      console.log("resp", resp, emailId);
      if (emailId) {
        const obj = {
          email: emailId,
        };
        dispatch(getUserLogin(obj));
        // const obj = {
        //   userId: emailId,
        // };
        // dispatch(getUserLoginByUserId(obj));
      }
      if (resp) {
        toast.success("User Profile Updated Successfully", toastConfig);
        setUser({ emailId: "", familyName: "", givenName: "" });
        // return <Navigate to="/dashboard" replace />;
        navigate("/dashboard");
      }
    } catch (err) {
      console.log(err);
      toast.error(err.message, toastConfig);
    }
  };

  const prepareUserData = () => {
    return {
      userId: user?.userId,
      emailId: user?.emailId,
      familyName: user?.familyName,
      givenName: user?.givenName,
      organization: user?.organization,
      isActive: user?.isActive,
      isAdmin: user?.isAdmin,
      roles: user?.roles,
    };
  };

  console.log("prepareUserData", prepareUserData());

  return (
    <div>
      <div className={styles.topheaderLeft} style={{ marginBottom: "40px" }}>
        {/* <b className={styles.headerTitle}>Review User Details</b> */}
        <div className={styles.headerTitle}>Add Users</div>
        <div className={styles.goremIpsumDolor1}>
          Add users to{" "}
          <span style={{ fontWeight: 600 }}>{organisationName}</span> group, You
          can do this later as well
        </div>
      </div>
      <CreateUser />
      {/* <Box sx={{ display: "flex" }}>
        <Box>
          <ButtonCta1
            text="Skip"
            //   onClick={(e) => handleSubmit(e)}
            variant="contained"
            disabled={false}
            width="83px"
            height="48px"
            color="#5a5a5a"
            bgColor="#e0e0e0"
          />
        </Box>
        <Box sx={{ marginLeft: "20px" }}>
          <ButtonCta1
            text="Continue"
            //   onClick={(e) => handleSubmit(e)}
            variant="contained"
            disabled={false}
            width="122px"
            height="48px"
          />
        </Box>
      </Box> */}
    </div>
  );
};

export default SetupOrganisation;
